import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  boxShadow: "none",
  background: "none",
}));

const AttachmentBox = ({
  previewAgent,
  renderInputFieldBorderColor,
  renderInputFieldBorderRadius,
  renderInputFieldBGColor,
  renderInputFieldTextColor,
}: any) => {
  return (
    <Box
      className="attach-main-box"
      sx={{
        mt: 1,
        flexGrow: 1,
        padding: previewAgent ? "20px 10px" : 1,
        border: "1px solid" + renderInputFieldBorderColor(),
        borderRadius: renderInputFieldBorderRadius(),
        backgroundColor: renderInputFieldBGColor(),
      }}
    >
      <Grid container>
        <Grid
          item
          md={3}
          xs={12}
          className="attach-grid-prev"
          sx={{
            padding: previewAgent ? "15px!important" : "10px",
          }}
        >
          <Box>
            <Item
              className="attch-icons"
              sx={{
                border: "1px solid " + renderInputFieldTextColor(),
                width: previewAgent ? "42px!important" : "30px",
                height: previewAgent ? "42px!important" : "30px",
                marginBottom: "8px",
                padding: previewAgent ? "10px" : "15px",
              }}
            >
              <i
                className="icon-screenshot icon-upload-attch-prev"
                style={{
                  color: renderInputFieldTextColor(),
                  fontSize: previewAgent ? "20px" : "10px",
                }}
              />
            </Item>
            <Typography
              className="atth-prev-text"
              sx={{
                color: renderInputFieldTextColor(),
                fontSize: previewAgent ? "12px" : "10px",
              }}
            >
              SCREENSHOT
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          md={3}
          xs={12}
          className="attach-grid-prev"
          sx={{
            borderLeft: "1px solid" + renderInputFieldBorderColor(),
            padding: previewAgent ? "15px!important" : "10px",
          }}
        >
          <Box>
            {" "}
            <Item
              className="attch-icons"
              sx={{
                border: "1px solid " + renderInputFieldTextColor(),
                width: previewAgent ? "42px!important" : "30px",
                height: previewAgent ? "42px!important" : "30px",
                marginBottom: "8px",
                padding: previewAgent ? "10px" : "15px",
              }}
            >
              <i
                className="icon-video icon-upload-attch-prev"
                style={{
                  color: renderInputFieldTextColor(),
                  fontSize: previewAgent ? "20px" : "10px",
                }}
              />
            </Item>
            <Typography
              className="atth-prev-text"
              sx={{
                color: renderInputFieldTextColor(),
                fontSize: previewAgent ? "12px" : "10px",
              }}
            >
              SCREEN RECORDER
            </Typography>
          </Box>
        </Grid>

        <Grid
          item
          md={3}
          xs={12}
          className="attach-grid-prev"
          sx={{
            borderLeft: "1px solid" + renderInputFieldBorderColor(),
            padding: previewAgent ? "15px!important" : "10px",
          }}
        >
          <Box>
            {" "}
            <Item
              className="attch-icons"
              sx={{
                border: "1px solid " + renderInputFieldTextColor(),
                width: previewAgent ? "42px!important" : "30px",
                height: previewAgent ? "42px!important" : "30px",
                marginBottom: "8px",
                padding: previewAgent ? "10px" : "15px",
              }}
            >
              <i
                className="icon-audio icon-upload-attch-prev"
                style={{
                  color: renderInputFieldTextColor(),
                  fontSize: previewAgent ? "20px" : "10px",
                }}
              />
            </Item>
            <Typography
              className="atth-prev-text"
              sx={{
                color: renderInputFieldTextColor(),
                fontSize: previewAgent ? "12px" : "10px",
              }}
            >
              CAPTURE AUDIO
            </Typography>
          </Box>
        </Grid>

        <Grid
          item
          md={3}
          xs={12}
          className="attach-grid-prev"
          sx={{
            borderLeft: "1px solid" + renderInputFieldBorderColor(),
            padding: previewAgent ? "15px!important" : "10px",
          }}
        >
          <Box>
            {" "}
            <Item
              className="attch-icons"
              sx={{
                border: "1px solid " + renderInputFieldTextColor(),
                width: previewAgent ? "42px!important" : "30px",
                height: previewAgent ? "42px!important" : "30px",
                marginBottom: "8px",
                padding: previewAgent ? "10px" : "15px",
              }}
            >
              <i
                className="icon-attach icon-upload-attch-prev"
                style={{
                  color: renderInputFieldTextColor(),
                  fontSize: previewAgent ? "20px" : "10px",
                }}
              />
            </Item>
            <Typography
              className="atth-prev-text"
              sx={{
                color: renderInputFieldTextColor(),
                fontSize: previewAgent ? "12px" : "10px",
              }}
            >
              ATTACH A FILE{" "}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AttachmentBox;
